// ANGULAR
import { Component, inject, input, Input } from '@angular/core';
import { BoardStore } from '../work-object/work-object-status-overview/work-object-status-overview-board/work-object-board.store';

@Component({
  selector: 'ng-bee-w-h-status-bar-util',
  templateUrl: './w-h-status-bar-util.component.html',
  styleUrls: ['./w-h-status-bar-util.component.scss'],
  standalone: false,
})
export class WHStatusBarUtilComponent {
  // INPUT STATE
  @Input() public statusLabel: string;
  @Input() public isActive: boolean = false;
  @Input() public mainBar: boolean = false;
  @Input() public matBadgeColor: 'primary' | 'accent' | 'warn' = 'accent';
  @Input() public statusArray: number[] = [];
  @Input() public workObjectStatusId: number;
  contextId = input<number>();
  // @Input('entriesCountArray') set _entriesCountArray(
  //   values: { id: number; count: number }[],
  // ) {
  //   this.entriesCountMap = new Map(
  //     values.map((entry) => [entry.id, entry.count]),
  //   );
  // }
  // entriesCountMap: Map<number, number> = new Map();
  boardStore = inject(BoardStore);
}
